//example actions
import*as actionTypes from'./actionTypes';export var openHelp=function openHelp(pageInfo){return{type:actionTypes.OPEN_HELP,pageInfo:pageInfo};};export var closeHelp=function closeHelp(){return{type:actionTypes.CLOSE_HELP};};


//////////////////
// WEBPACK FOOTER
// ./src/store/actions/help.js
// module id = 1861
// module chunks = 29